import { render, staticRenderFns } from "./RegionImport.vue?vue&type=template&id=43a01cfa&scoped=true&"
import script from "./RegionImport.vue?vue&type=script&lang=js&"
export * from "./RegionImport.vue?vue&type=script&lang=js&"
import style0 from "./RegionImport.vue?vue&type=style&index=0&id=43a01cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a01cfa",
  null
  
)

export default component.exports